var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-8  h-100 eventdetail"},[(_vm.mode === 'scan')?_c('Scanner'):_c('Event')],1)}
var staticRenderFns = []

export { render, staticRenderFns }